import { callGetUserData } from "./middle-tier-calls";
import { showMessage } from "./message-helper";
import { handleClientSideErrors } from "./error-handler";
import { dialogFallback } from "./fallbackauthdialog";
import { logger } from "./tslog";

let retryGetMiddletierToken = 0;

export async function getTokens(callback): Promise<void> {
  try {
    let middletierToken: string;

    try {
      middletierToken = await OfficeRuntime.auth.getAccessToken({
        allowSignInPrompt: false,
        allowConsentPrompt: false,
      });
    } catch (error) {
      logger.error("Failed to get token silently:", error);
      middletierToken = await OfficeRuntime.auth.getAccessToken({
        allowSignInPrompt: true,
        allowConsentPrompt: true,
      });
    }

    let response: any = await  callGetUserData(middletierToken);

    if (!response) {
      logger.info("Backend Not Respond");
      throw new Error("Middle tier didn't respond");
    } else if (response.claims) {
      let mfaMiddletierToken: string = await OfficeRuntime.auth.getAccessToken({
        authChallenge: response.claims,
      });

      response = await callGetUserData(mfaMiddletierToken);
    }

    if (response.error) {
      logger.error("Error: ", response.error);

      handleAADErrors(response, callback);
    } else {
      callback(response);
    }
  } catch (exception) {
    logger.error("error", exception);
    if (exception.code) {
      if (handleClientSideErrors(exception)) {
        dialogFallback(callback);
      }
    } else {
      showMessage("EXCEPTION: " + JSON.stringify(exception));
      throw exception;
    }
  }
}

function handleAADErrors(response: any, callback: any): void {
  if (response.error_description.indexOf("AADSTS500133") !== -1 && retryGetMiddletierToken <= 0) {
    retryGetMiddletierToken++;
    getTokens(callback);
  } else {
    dialogFallback(callback);
  }
}
